var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddUsers = function SvgAddUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "3B51F236-A624-41D9-B1B6-7A73C7B94101")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DASHBOARD->-Overview-Invite",
    transform: "translate(-289.000000, -319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-users",
    transform: "translate(290.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_User_1433978",
    fill: "#000000",
    fillRule: "nonzero",
    strokeWidth: 0.53865
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81497036,0.0457142857 C5.62452281,0.0457142857 3.84881423,1.77517434 3.84881423,3.90857143 C3.84881423,6.04196852 5.62452281,7.77142857 7.81497036,7.77142857 C10.0054179,7.77142857 11.7811265,6.04196852 11.7811265,3.90857143 C11.7811265,2.88407802 11.3632648,1.90154519 10.6194662,1.17711895 C9.87566769,0.452692709 8.86686036,0.0457142857 7.81497036,0.0457142857 Z M7.81497036,7.31428571 C5.88374737,7.31428571 4.31818182,5.78949549 4.31818182,3.90857143 C4.31818182,2.02764737 5.88374737,0.502857143 7.81497036,0.502857143 C9.74619334,0.502857143 11.3117589,2.02764737 11.3117589,3.90857143 C11.3117589,5.78949549 9.74619334,7.31428571 7.81497036,7.31428571 L7.81497036,7.31428571 Z",
    id: "Shape",
    stroke: "#353531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4744981,8.70252291 C11.1712124,8.6048109 10.9761557,8.54587469 10.8893281,8.52571429 C10.8283287,8.52571429 10.7689084,8.54510533 10.719651,8.58108624 L10.701581,8.59428571 C8.96888778,9.80379605 6.63758455,9.80379605 4.9048913,8.59428571 L4.88682137,8.58108624 C4.83756391,8.54510533 4.77814365,8.52571429 4.71714427,8.52571429 L4.71714427,8.52571429 C2.00644808,9.12732947 0.0919825461,11.4866231 0.117341897,14.1942857 L0.117341897,15.9542857 L15.5125988,15.9542857 L15.5125988,14.1942857 C15.5125988,14.1028571 15.5125988,14.0114286 15.5125988,13.92 C15.3724299,11.5140941 13.7683746,9.44154992 11.4744981,8.70252291 Z M15.0432372,15.4971429 L0.586690233,15.4971429 L0.586690233,14.1942857 C0.580058665,11.744606 2.2971148,9.60930793 4.74061265,9.02857143 L4.88142292,9.12 L5.04570158,9.21142857 L5.23344862,9.32571429 L5.39772727,9.41714286 L5.60894269,9.50857143 L5.77322134,9.57714286 L5.98443676,9.64571429 L6.14871542,9.71428571 L6.38339921,9.78285714 L6.54767787,9.82857143 L6.78236166,9.87428571 L8.77717391,9.87428571 L9.01185771,9.82857143 L9.17613636,9.78285714 L9.41082016,9.71428571 L9.59856719,9.64571429 L9.80978261,9.57714286 L9.97406126,9.50857143 L10.1852767,9.41714286 L10.3495553,9.32571429 L10.5373024,9.21142857 L10.701581,9.09714286 L10.8423913,9.00571429 C13.3081774,9.57787546 15.0469716,11.7255073 15.0432372,14.1942857 L15.0432372,15.4971429 Z",
    id: "Shape",
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.2198997,5.26270605 L16.2198997,9.39877966",
    id: "Line",
    stroke: "#000000",
    strokeWidth: 1.2312,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3164883,5.08208906 L16.3164883,9.39410142",
    id: "Line",
    stroke: "#000000",
    strokeWidth: 1.2312,
    strokeLinecap: "round",
    transform: "translate(16.316488, 7.238095) rotate(-90.000000) translate(-16.316488, -7.238095) "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-users.6be76dfe.svg";
export { ForwardRef as ReactComponent };